import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserSearchCriteria} from 'web-angular-client';
import {SearchService} from '../../../sdk/component/search/search.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {UserSearchCriteriaImpl} from '../../../sdk/component/search/user-search-criteria';
import {SearchFilterBase} from '../../../sdk/component/search/search-filter-base';
import {FilterPersistenceService} from '../../../sdk/component/search/filter-persistence.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-user-invitation-search',
    templateUrl: './user-invitation-search.component.html',
    styleUrls: ['./user-invitation-search.component.scss'],
    standalone: false
})
export class UserInvitationSearchComponent extends SearchFilterBase implements OnInit, OnDestroy
{
    form: UntypedFormGroup;
    private MOBILE = 'mobile';
    private EMAIL = 'email';
    private EMAIL_ADDRESS = 'emailAddress';
    private MOBILE_NO = 'mobileNo';
    private userSearchCriteria: UserSearchCriteria = new UserSearchCriteriaImpl();

    constructor(
        protected searchDataService: SearchService,
        protected filterPersistenceService: FilterPersistenceService,
        protected route: ActivatedRoute,
        private formBuilder: UntypedFormBuilder,
        protected ngxLoader: NgxUiLoaderService)
    {
        super(searchDataService, ngxLoader, filterPersistenceService, route);
    }

    get activeTab(): string
    {
        return this._activeTab;
    }

    get tabActive(): boolean
    {
        return !!this.activeTab;
    }

    ngOnInit(): void
    {
        this.form = this.formBuilder.group({
            email: ['', Validators.email],
            mobile: ['', Validators.maxLength(10)]
        });

        this.initializeSearchPage();
    }

    ngOnDestroy(): void
    {
        clearInterval(this.interval);
    }

    setSearchCriteria(event: any)
    {
        let inputId = event.target.id;
        let val = event.target.value;
        this.setUserInvitationSearchCriteria(inputId, val);
    }

    getSearchCriteria(): any
    {
        return this.userSearchCriteria;
    }

    setUserInvitationSearchCriteria(id: string, val: any)
    {
        switch (id)
        {
            case this.MOBILE:
                this.userSearchCriteria.mobile = <string> val;
                break;
            case this.EMAIL:
                this.userSearchCriteria.email = <string> val;
                break;
        }
    }

    getTabContent(event: any)
    {
        this._activeTab = event.target.id.toString();
        this.saveCurrentFilters();
    }

    clear(activeTab: string)
    {
        switch (activeTab)
        {
            case this.EMAIL_ADDRESS:
                this.userSearchCriteria.email = null;
                this.form.get(this.EMAIL).reset();
                break;
            case this.MOBILE_NO:
                this.userSearchCriteria.mobile = null;
                this.form.get(this.MOBILE).reset();
                break;
        }

        this.search();
    }

    clearAll()
    {
        this.userSearchCriteria = new UserSearchCriteriaImpl();
        this.form.reset(this.userSearchCriteria);
        this.search();
    }

    disableClearAll()
    {
        return !this.form.dirty;
    }

    disableClear(activeTab: string): boolean
    {
        switch (activeTab)
        {
            case this.EMAIL_ADDRESS:
                return !this.form.get(this.EMAIL).dirty;
            case this.MOBILE_NO:
                return !this.form.get(this.MOBILE).dirty;
            default:
                return true;
        }
    }

    setFilters(): void
    {
        this.applyFilters(
            this.form,
            (criteria: UserSearchCriteria) => this.userSearchCriteria = criteria,
            null
        );
    }
}